module.exports = __webpack_public_path__ + "img/archive.70b32e.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/underscore-template-loader/file-loader.js?url=%2Fimg%2Farchive.svg!./src/img/archive.svg
 ** module id = 31
 ** module chunks = 0
 **/